module.exports = __webpack_public_path__ + "img/cancel.06dac4d5.png";